import { lazy } from 'react';

import { LazyLoad } from '@/shared/ui';

export const RadiologistReportDocumentRoute = LazyLoad(
  lazy(() =>
    import('./radiologist-report-document').then((module) => ({
      default: module.RadiologistReportDocument,
    })),
  ),
);
